import React, {Component} from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import {Box, CircularProgress} from '@material-ui/core';
import styled from 'styled-components';
import {theme} from '../theme/theme';
import company from '../pages/client/company'
import Company from './company';
import {MainContent} from './styled'

class CompanyList extends Component {
    state={
        companies: [],
        limit: 5,
        hasMore: true,
        count: 0,
        message: 'Loading...',
    }

    componentDidMount(){
        this.countData();
        this.loadData();
    }

    componentDidUpdate(){
        if (this.props.refresh) {
            console.log('refresh')
            this.countData();
            this.loadData();
        }
        // this.countData();
        // this.loadData();
    }

    loadData = () => {
        const {token, sorting, filter} = this.props;
        let sortString;
        let filterString;
        console.log(sorting)
        switch (sorting) {
            case '1':
                sortString = '+name';
                break;
            case '2':
                sortString = '-name';
                break;
            default:
                sortString = '-updatedAt';
                break;
        }

        switch (filter) {
            case '1': 
                filterString = 'active';
                break;
            case '2':
                filterString = 'disabled';
                break;
            default:
                filterString = '';
        }
        if (filterString !== '') {
            company.getList(token, {limit: this.state.limit,sort:sortString,status:filterString}).then(({data}) => { 
                // console.log(data)
                if (data || data.data ) {
                    console.log(data.data)
                    this.setState(
                        {...this.state, companies:data.data}
                    );
                } else {
                    console.log("invalid data");
                }
            }).catch((err) => {
                console.log(err.message)
            })
        } else {
            company.getList(token, {limit: this.state.limit,sort:sortString}).then(({data}) => { 
                // console.log(data)
                if (data || data.data ) {
                    console.log(data.data)
                    this.setState(
                        {...this.state, companies:data.data}
                    );
                } else {
                    console.log("invalid data");
                }
            }).catch((err) => {
                console.log(err.message)
            })
        }
        
    }

    countData = () => {
        const {token, filter} = this.props;
        let message = this.state.message;
         let filterString;
         switch (filter) {
            case '1': 
                filterString = 'active';
                break;
            case '2':
                filterString = 'disabled';
                break;
            default:
                filterString = '';
        }
        if (filter !== '0') {
            company.getList(token,{status:filterString}).then(({data}) => {
                if (data) {
                    if (data.data.length === 0) {
                        message = 'No data found'
                    }
                    this.setState(
                        {...this.state, count:data.data.length, message: message}
                    );
                }
            }).catch(console.error);
        } else {
            company.getList(token).then(({data}) => {
                if (data) {
                    if (data.data.length === 0) {
                        message = 'No data found'
                    }
                    this.setState(
                        {...this.state, count:data.data.length, message: message}
                    );
                }
            }).catch(console.error);
        }
        
    }

    fetchMoreData = () => {
        if (this.state.companies.length >= this.state.count) {
            this.setState({ hasMore: false });
            return;
        }
        //console.log(this.state.trips.length, this.state.count)
        this.setState({...this.state, limit: this.state.limit+5})
        this.loadData();
    };

    render() {
       const {companies,count,hasMore,message} = this.state;
       const {token, onchange, LoadData, setRefresh} = this.props;
        return (
           <MainContent id="companies">
               { companies.length > 0 ?
                <InfiniteScroll
                    dataLength={companies.length} //This is important field to render the next data
                    next={this.fetchMoreData}
                    hasMore={hasMore}
                    loader={<Box display="flex" alignItems="center" justifyContent="center"><CircularProgress color="secondary" /></Box>}
                    endMessage={
                        <Box textAlign="center">
                        <b>Yay! You have seen it all</b>
                        </Box>
                    }
                    scrollableTarget="companies"
                    >
                {companies.map((obj,key)=>
                    <Company data={obj} key={key} token={token} onchange={onchange} LoadData={LoadData} setRefresh={setRefresh} />
                )}
                </InfiniteScroll>
                : <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                    {message === 'Loading...' &&
                    <CircularProgress color="secondary" />
                    }
                    <br/>{message}</Box> }
           </MainContent>
        )
    }
};

export default CompanyList;